import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import Tooltip from '@mui/material/Tooltip'
import React from 'react'
import PropTypes from 'prop-types'
import { NumericFormat } from 'react-number-format'

import { Box, Typography } from '@mui/material'

const BillingField = ({
  label = '',
  value = '',
  isNumberFormat = false,
  prefix = '',
  suffix = '',
  variant = 'body1',
  mb = 1,
  tooltip = '',
  LabelTypographyProps,
  ValueTypographyProps,
}) => (
  <Box display="flex" justifyContent="space-between" mb={mb} alignItems="center">
    <Box alignItems="center" display="flex" gap={0.5}>
      <Typography color="text.secondary" variant="body1" {...LabelTypographyProps}>
        {label}
      </Typography>
      {tooltip && (
        <Tooltip title={tooltip}>
          <InfoOutlinedIcon color="disabled" fontSize="small" />
        </Tooltip>
      )}
    </Box>
    <Typography variant={variant} {...ValueTypographyProps}>
      {isNumberFormat ? (
        <NumericFormat
          value={value}
          fixedDecimalScale
          displayType="text"
          thousandSeparator
          decimalSeparator="."
          decimalScale={2}
          prefix={prefix}
          suffix={suffix}
        />
      ) : (
        value
      )}
    </Typography>
  </Box>
)

BillingField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]),
  isNumberFormat: PropTypes.bool,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  variant: PropTypes.string,
  mb: PropTypes.number,
  tooltip: PropTypes.string,
  LabelTypographyProps: PropTypes.object,
  ValueTypographyProps: PropTypes.object,
}

export default BillingField
